import React from "react";
import { Routes, Route } from "react-router-dom";
import Navbar from "./components/Navbar";
import Home from "./components/Home";
import About from "./components/About";
import "./App.css";
import Contact from "./components/Contact";
import Services from "./components/Services";
import Footer from "./components/misc/Footer";
import Login from "./components/Login";
import Register from "./components/Register";
import Logout from "./components/Logout";
import Bill from "./components/Bill";
import Product from "./components/Products";
import ProductDesc from "./components/Productdesc";
import NewProduct from "./components/Actions/Newproduct";

function App() {
  return (
    <div className="App">
      <Navbar />
      <Routes>
        <Route index element={<Home />} />
        <Route path="/about" element={<About />} />
        <Route path="/services" element={<Services />} />
        <Route path="/services/bill" element={<Bill />} />
        <Route path="/services/products" element={<Product />} />
        <Route path="/services/products/productdesc" element={<ProductDesc />}/>
        <Route path="/services/products/Newproduct" element={<NewProduct/>}/>
        <Route path="/contact" element={<Contact />} />
        <Route path="/login" element={<Login />} />
        <Route path="/register" element={<Register />} />
        <Route path="/logout" element={<Logout />} />
      </Routes>
      <Footer />
    </div>
  );
}

export default App;
